import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {HideInvalidDataPipe} from "./hide-invalid-data.pipe";

@NgModule({
  imports: [CommonModule],
  declarations: [HideInvalidDataPipe],
  exports: [HideInvalidDataPipe]
})
export class PipeModule {
}
